import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CTAButton } from './ui/CTAButton';
const includes = ['Entregá tu planificación anual completa en una sola tarde', 'Diseñá clases que los alumnos no quieran que terminen', 'Corregí 120 exámenes en una tarde de martes', 'Resolvé toda tu documentación institucional en minutos', 'Documentar la inclusión (PPI) con criterio pedagógico real', 'Respondé cualquier WhatsApp difícil de familia en 8 minutos'];
export function IncludesSection() {
  return <section className="py-8 md:py-16 px-4 bg-brand-dark" data-id="element-177">
      <div className="max-w-4xl mx-auto" data-id="element-178">
        <h2 className="text-3xl md:text-4xl font-black text-center text-white mb-5 md:mb-10" data-id="element-179">
          Cada tomo incluye:
        </h2>

        <div className="bg-white/5 p-5 md:p-10 rounded-3xl shadow-xl border border-white/10 mb-6 md:mb-10" data-id="element-180">
          <ul className="space-y-3 md:space-y-5" data-id="element-181">
            {includes.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-182">
                <div className="bg-brand-green/20 p-1 rounded-full flex-shrink-0 mt-1" data-id="element-183">
                  <CheckIcon className="w-6 h-6 text-brand-green" strokeWidth={3} data-id="element-184" />
                </div>
                <span className="text-xl font-medium text-gray-200" data-id="element-185">
                  {item}
                </span>
              </li>)}
          </ul>
        </div>

        <div className="max-w-xl mx-auto" data-id="element-186">
          <CTAButton text="→ QUIERO TODO ESTO AHORA" href="#compra" data-id="element-187" />
        </div>
      </div>
    </section>;
}